



















































































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { getModule } from "vuex-module-decorators";
import { Logger } from 'aws-amplify';
import StorageImage from "@/components/common/StorageImage.vue";
import Decisions from "@/store/modules/Decisions";
import Users from "@/store/modules/Users";
import CommentBadge from '@/components/comments/CommentBadge.vue';
import Choices from "@/store/modules/Choices";
import Comments, { ResourceType } from "@/store/modules/Comments";
import WorkspaceOptions from "@/store/modules/WorkspaceOptions";
import ThreadedCommentDisplay from "@/components/comments/ThreadedCommentDisplay.vue";
import Viewpoints from "@/store/modules/Viewpoints";

const decisionsModule = getModule(Decisions);
const usersModule = getModule(Users);
const viewpointModule = getModule(Viewpoints);
// Logger.LOG_LEVEL = "DEBUG";
const logger = new Logger("ViewpointCard.vue");

@Component({
    components: { StorageImage, CommentBadge, ThreadedCommentDisplay },
})
export default class ViewpointCard extends Vue {

    @Prop({type: Boolean, default: false})
    disabled!: boolean;

    @Prop({type: String, default: ''})
    name!: string;

    @Prop({type: String, default: ''})
    userId!: string;

    @Prop({type: String, default: ''})
    color!: string;

    @Prop({type: String, default: ''})
    size!: string;

    @Prop({type: Number, default: 175})
    chipWidth!: number;

    @Prop({type: String, default: ''})
    viewpointId!: string;

    @Prop({type: String, default: ''})
    choiceId!: string;

    // Due to bad CSS rule on <v-chip><v-avatar></v-avatar></v-chip> combinations
    // width and/or height of <v-chip> & <v-avatar> will be extrploated based on "this.size"
    /*

    @Prop({type: Number, default: 32})
    chipHeight!: number;

    @Prop({type: Number, default: 32})
    width!: number;

    @Prop({type: Number, default: 175})
    height!: number;

    */
    private show = false;
    private user: any = {
        first: '',
        last: '',
        phone: '',
        email: '',
        image: '',
    };


    mounted() {
        if (this.userProfiles.hasOwnProperty(this.userId)) {
            this.user = Object.assign(this.user, this.userProfiles[this.userId]);
        }
    }

    get userProfiles() {
        return decisionsModule.selectedDecisionUsers;
    }

    @Watch('userProfiles')
    private userProfileChanged() {
        if (this.userProfiles.hasOwnProperty(this.userId)) {
            this.user = Object.assign(this.user, this.userProfiles[this.userId]);
        }
    }

    /**
     *
     *  HEIGHTS OF <v-chip> BASED ON this.size
     *
     *  x-small = 16px
     *  small   = 24px
     *  default = 32px
     *  large   = 54px
     *  x-large = 66px
     *
     */

    get height() {
        switch (this.size) {
            case 'x-small':
                return 16;
            case 'small':
                return 24;
            case 'large':
                return 54;
            case 'x-large':
                return 66;
            default:
                return 32;
        }
    }

    get avatarStyles() {
        return {
            'width': this.height - 8 + 'px !important',
            'min-width': this.height - 8 + 'px !important',
            'max-width': this.height - 8 + 'px !important',
            'height': this.height - 8 + 'px !important',
            'min-height': this.height - 8 + 'px !important',
            'max-height': this.height - 8 + 'px !important',
            'font-size': this.height / 2 - 4 + 'px !important',
            'position': 'relative',
            'margin-left': '-8px',
        };
    }

    get chipStyles() {
        return {
            'width': this.chipWidth + 'px',
            'min-width': this.chipWidth + 'px',
            'max-width': this.chipWidth + 'px',
            'height': this.height + 'px',
            'min-height': this.height + 'px',
            'max-height': this.height + 'px',
            'position': 'relative',
            'letter-spacing': '-0.0125rem',
            'background': (this.disabled ? 'rgba(0, 0, 0, 0.03) !important' : ''),
        };
    }

    private chipSize(size: string) {
        if (size === this.size) {
            return true;
        }
        return false;
    }

    get decisionId() {
        return decisionsModule.selectedDecisionId
    }

    get resource() {
        if (this.viewpointId) {
            return {
                name: this.name,
                id: this.viewpointId,
                type: ResourceType.VIEWPOINT
            }
        }
    }

    get secondaryResource() {
        if (getModule(Choices).choices[this.choiceId]) {
            return {
                id: this.choiceId,
                type: ResourceType.CHOICE,
                name: getModule(Choices).choices[this.choiceId].name
            }
        }
    }

    get tertiaryResource() {
        return {
            id: "THREAD",
            type: ResourceType.FACTOR,
            name: "THREAD"
        }
    }

    private async selectViewpoint() {
        await viewpointModule.selectActiveViewpoint(this.viewpointId);
    }

    get activeViewpoint() {
        return viewpointModule.activeViewpointId;
    }

}

